import { render, staticRenderFns } from "./NavBtn.vue?vue&type=template&id=48463b5a&"
import script from "./NavBtn.vue?vue&type=script&lang=js&"
export * from "./NavBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports